<template>
  <cReport
    v-if="!isSystemReport"
    :reportName="reportName"
    :listReportData="lsReportData"
    :agenttype="agentType"
    :listReportTableData="lsReportTableData"
    :lsReportFields="getReportTableFields()"
    @submit="onGetTopupProjectionReport"
    :defaultFields="defaultColumns"
    :columnsToMerge="columnsToMerge"
  />
</template>

<script>
import cReport from "../../components/report/cReport";
import {
  PATHNAME,
  COMPONENT_NAME,
  ALERT_MODAL_STATUS,
  ORDER,
  DATE_TIME_FORMAT,
  AGENT_TYPE
} from "../../../src/util/constants";
import apiPostpaidTopupProjectionReport from "../../../src/services/apiPostpaidTopupProjectionReport";
import apiPrepaidTopupProjectionReport from "../../../src/services/apiPrepaidTopupProjectionReport";
import apiSystemTopupForecastReport from "../../../src/services/apiSystemTopupForecastReport";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import {
  addClassToBody,
  removeClassBody,
  handleJWT,
  getErrorAlertValue,
  cloneDeep,
  cloneData,
  OrderByList
} from "../../../src/util/util";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import Logger from "../../services/logger";
import BaseConfiguration from "../../config/base.js";
import { mapGetters } from "vuex";
export default {
  name: COMPONENT_NAME.TOPUP_PROJECTION_REPORT,
  components: {
    cReport
  },
  data: () => {
    return {
      reportName: COMPONENT_NAME.TOPUP_PROJECTION_REPORT,
      lsReportData: null,
      lsReportTableData: null,
      agentType: null,
      isSystemReport: false,
      lsReportFields: [],
      defaultColumns: null,
      columnsToMerge: null
    };
  },

  methods: {
    async onGetTopupProjectionReport(pReportQuery) {
      try {
        if (BaseConfiguration.isDebug)
          console.log("onGetTopupProjectionReport");

        if (this.agentType == AGENT_TYPE.PREPAID) {
          this.lsReportData = await this.getPrepaidTopupProjectionReport(
            pReportQuery.fromDate,
            pReportQuery.toDate,
            pReportQuery.lsCurrCode
          );
        } else {
          this.lsReportData = await this.getPostpaidTopupProjectionReport(
            pReportQuery.fromDate,
            pReportQuery.toDate,
            pReportQuery.lsCurrCode
          );
        }

        if (this.lsReportData && this.lsReportData.report) {
          this.lsReportTableData = this.lsReportData.report;
        }else{
          this.lsReportTableData=[];
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TOPUP_PROJECTION_REPORT,
          "error in onGetTopupProjectionReport",
          err.toString(),
          "onGetTopupProjectionReport",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async getPrepaidTopupProjectionReport(pFromDate, pToDate, pLsCurrCode) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug)
          console.log("getPrepaidTopupProjectionReport");

        let systemReportReq = apiPrepaidTopupProjectionReport.buildRequest(
          pFromDate,
          pToDate,
          pLsCurrCode
        );
        if (systemReportReq) {
          let systemReportRes = await apiPrepaidTopupProjectionReport.getResponse(
            systemReportReq
          );

          if (systemReportRes) {
            if (VALIDATE_SUCCESS_RES(systemReportRes)) {
              retValue = systemReportRes.data.data;
            } else {
              //if status error
              retValue = null;
              let error = getErrorMessage(systemReportRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.alertValue = getErrorAlertValue(error);
              }
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TOPUP_PROJECTION_REPORT,
          "error in getPrepaidTopupProjectionReport",
          err.toString(),
          "getPrepaidTopupProjectionReport",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    async getPostpaidTopupProjectionReport(
      pFromDate,
      pToDate,
      pLsCurrCode,
      pAirlineCode,
      pProvider
    ) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug)
          console.log("getPostpaidTopupProjectionReport");

        let systemReportReq = apiPostpaidTopupProjectionReport.buildRequest(
          pFromDate,
          pToDate,
          pLsCurrCode
        );
        if (systemReportReq) {
          let systemReportRes = await apiPostpaidTopupProjectionReport.getResponse(
            systemReportReq
          );

          if (systemReportRes) {
            if (VALIDATE_SUCCESS_RES(systemReportRes)) {
              retValue = systemReportRes.data.data;
            } else {
              //if status error
              retValue = null;
              let error = getErrorMessage(systemReportRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.alertValue = getErrorAlertValue(error);
              }
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TOPUP_PROJECTION_REPORT,
          "error in getPostpaidTopupProjectionReport",
          err.toString(),
          "getPostpaidTopupProjectionReport",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getReportTableFields() {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getReportTableFields");

        retValue = [
          {
            key: "booked_ts",
            label: this.$t("cReport.reservationDate"),
                                                isLocked: false

          },
          {
            key: "daysLeft",
            label: this.$t("cReport.daysLeft"),
                                                isLocked: false

          },

          {
            key: "description",
            label: this.$t("cReport.description"),
                                                isLocked: false

          },
          {
            key: "booking_ref",
            label: this.$t("cReport.reference"),
                                                isLocked: false

          },
          {
            key: "orderId",
            label: this.$t("cReport.reservationId"),
                                                isLocked: true

          },
          {
            key: "bookedBy",
            label: this.$t("cReport.bookedBy"),
                                                isLocked: false

          },
          {
            key: "bookingAmount",
            label: this.$t("cReport.holdBookings"),
                                                isLocked: false

          },
          {
            key:
              this.agentType == AGENT_TYPE.PREPAID
                ? "afterBalance"
                : "availableLimit",
            label: this.$t("cReport.availableLimit"),
                                                isLocked: false

          }
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TOPUP_PROJECTION_REPORT,
          "error in getReportTableFields",
          err.toString(),
          "getReportTableFields",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    }
  },
  computed: {
    ...mapGetters("sSysLogin", {
      ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
    }),
    ...mapGetters("sAgtLogin", {
      AGENT_SIGNIN_RES: "GET_SIGNIN_RES"
    })
  },
  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
      if (this.AGENT_SIGNIN_RES) {
        this.isSystemReport = false;

        this.agentType = this.AGENT_SIGNIN_RES.logoDetails.agenttype;
      } else {
        this.isSystemReport = true;
      }
      this.defaultColumns = [
        {
          key: "booked_ts",
          label: this.$t("cReport.reservationDate"),
          isLocked: false
        },
        {
          key: "daysLeft",
          label: this.$t("cReport.daysLeft"),
          isLocked: false
        },

        {
          key: "description",
          label: this.$t("cReport.description"),
          isLocked: false
        },
        {
          key: "booking_ref",
          label: this.$t("cReport.reference"),
          isLocked: false
        },
        {
          key: "orderId",
          label: this.$t("cReport.reservationId"),
          isLocked: true
        },
        {
          key: "bookedBy",
          label: this.$t("cReport.bookedBy"),
          isLocked: false
        }
      ];
      this.columnsToMerge = [
        {
          key: "bookingAmount",
          label: this.$t("cReport.holdBookings"),
                                              isLocked: false

        },
        {
          key:
            this.agentType == AGENT_TYPE.PREPAID
              ? "afterBalance"
              : "availableLimit",
          label: this.$t("cReport.availableLimit"),
                                              isLocked: false

        }
      ];
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.TOPUP_PROJECTION_REPORT,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  }
};
</script>

<style>
</style>